module.exports = __webpack_public_path__ + "img/deep-MT5.947242ce.png";